<template>
  <div>
    <Header :self="self" />
    <div class="container main">
      <div class="content">
        <h2>Quozio Bookmarklet</h2>
        <p>
          Just drag the image below onto your browser's bookmark bar to install. 
        </p>

        <p>
          Then, highlight text on any web page and hit the "Quote with Quozio" button. The bookmarklet will turn the selected text into a image that you can share on Facebook, Pinterest, email and more...
        </p>

        <p>
          <a href="javascript:function%20loadScript(scriptURL)%20{%20var%20scriptElem%20=%20document.createElement('scr' + 'ipt');%20scriptElem.setAttribute('language',%20'JavaScript');%20scriptElem.setAttribute('src',%20scriptURL);%20scriptElem.setAttribute('id',%20'quotemarklet');%20document.body.appendChild(scriptElem);}%20loadScript('//quozio.com/bookmarklet/page.js?x='+Math.random());" title="Quote with Quozio"><img id="bookmarkletButton" name="bookmarkletButton" src="/images/get_bookmarklet.png" alt="Quote with Quozio" title="Quote with Quozio" class="bookmarklet-button" onMouseOver="document.bookmarkletButton.src='/images/get_bookmarklet_hover.png';" onMouseOut="document.bookmarkletButton.src='/images/get_bookmarklet.png';" /></a><br /><br />
        </p>

      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  import { mapState } from "vuex";

  export default {
    components: { Header, Footer },
    async asyncData({ store, app }) {
      await store.dispatch("self/get", app.$cookies);
    },
    head() {
      return {
        title: "Quozio - Privacy Policy",
        meta: [
          { hid: "description", name: "description", content: "Quozio's privacy policy" }
        ]
      }
    },
    methods: {
    },
    computed: {
      ...mapState("self", { self: "self" }),
    },
  };
</script>
